/**
 * Per-page SEO tags. React 19 hoists <title>, <meta> and <link> rendered
 * anywhere in the tree into <head>, so no helmet dependency is needed.
 */
const SITE_URL = 'https://firstdance.app'
const DEFAULT_OG_IMAGE = `${SITE_URL}/logo512.png`

export default function Seo({ title, description, path = '', image = DEFAULT_OG_IMAGE }) {
    const url = `${SITE_URL}${path}`

    return (
        <>
            <title>{title}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />

            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="First Dance" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={image} />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
        </>
    )
}
